<template>
  <div>
    <label-list v-show="tabType === 1" @handleShow="handleShow" />
    <label-two-list v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import labelList from './list.vue'
import labelTwoList from './twoList.vue'
export default {
  components: { labelList, labelTwoList },
  data() {
    return {
      tabType: 1,
      rowItem: null,
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>